import _get from 'lodash/get'
import { fromJS } from 'immutable'
import {
  GET_MAX_REACH_DATA,
  setMaxReachData,
  setMaxReachError,
  setMaxReachProcessing,
} from './actions'
import {
  getMaxReach,
} from '..'

const log = console

async function getMaxReachDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { campaignId, videos, series } = action.payload

  try {
    store.dispatch(setMaxReachProcessing({
      processing: true,
      campaignId,
    }))

    const videoIds = videos.join(',')
    const seriesIds = series.join(',')

    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      videoIds,
      seriesIds,
    }

    const data = await getMaxReach(options)

    store.dispatch(setMaxReachData({
      campaignId,
      data: fromJS(_get(data, 'count')),
    }))
  } catch (error) {
    log.error(error, 'Error getting max reach from video analytics.')
    store.dispatch(setMaxReachError({
      campaignId,
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_MAX_REACH_DATA:
      getMaxReachDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
